<template>
  <mdb-modal centered scrollable :show="mostrarModal" @close="cerrar">
    <mdb-modal-body>
      <header class="h4-responsive">Solicitar nota de crédito</header>
      <div class="col-12">
        <mdb-input v-model.trim="solicitud" type="textarea" label="Solicitud" :class="['my-2', validarValores.icon]"
          :validation="validarValores.value === false" :invalidFeedback="validarValores.mensaje" outline />
      </div>
      <div :class="['row justify-content-around mt-4', { 'cursor-not-allowed': botonDeshabilitado }]"
        :title="botonDeshabilitado ? 'Espera por favor, estamos procesando la solicitud' : ''">
        <mdb-btn flat dark-waves icon="times" :disabled="botonDeshabilitado" @click="cerrar">
          Cancelar
        </mdb-btn>
        <mdb-btn color="primario" :icon="botonDeshabilitado ? 'circle-notch' : iconoBotonConfirmar"
          :icon-class="[{ 'fa-spin': botonDeshabilitado }]" :disabled="!validarValores.value"
          @click="$emit('confirmar', solicitud)">
          Solicitar
        </mdb-btn>
      </div>
    </mdb-modal-body>
  </mdb-modal>
</template>

<script>
import {mdbBtn, mdbModal, mdbModalBody, mdbInput} from 'mdbvue';
export default {
  name: 'ConfirmacionEliminar',
  components: {
    mdbBtn,
    mdbModal,
    mdbModalBody,
    mdbInput,
  },
  props: {
    botonDeshabilitado: {
      type: Boolean,
      required: true,
    },
    iconoBotonConfirmar: {
      type: String,
      default: 'check',
    },
    mostrarModal: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      solicitud: '',
      validarValores: {},
    };
  },
  methods: {
    validar(campo) {
      if (this.mostrarModal) {
        if (campo.trim() === '') {
          return this.validarValores = {
            value: false,
            mensaje: 'No puedes enviar campo vacío',
            icon: 'invalido',
          };
        }
        if (!campo) {
          return this.validarValores = {
            value: false,
            mensaje: 'Campo requerido',
            icon: 'invalido',
          };
        }
        return this.validarValores = {
          value: true,
          mensaje: '',
          icon: 'valido',
        };
      }
    },
    cerrar() {
      this.$emit('cerrar');
      this.limpiar();
    },
    limpiar() {
      this.solicitud = '';
      this.validarValores = {
        value: null,
        mensaje: '',
        icon: '',
      };
    },
  },
  watch: {
    solicitud(newVal) {
      this.validar(newVal);
    },
    mostrarModal(val) {
      this.limpiar();
    },
  },
};
</script>

<style lang="scss" scoped>

.icono {
  color: $error;
  margin: 1.5rem 0;
}

header {
  margin-bottom: .75rem;
}

p {
  color: $gris-muted;
  line-height: 1.3;
}
</style>
